import { render, staticRenderFns } from "./NovaLicencaBtn.vue?vue&type=template&id=6a480548&scoped=true&"
import script from "./NovaLicencaBtn.vue?vue&type=script&lang=js&"
export * from "./NovaLicencaBtn.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a480548",
  null
  
)

export default component.exports